import { ColumnType } from "antd/lib/table";
import moment from "moment";

export const flatten = (into, node) => {
  if (node == null) return into;
  if (Array.isArray(node)) return node.reduce(flatten, into);
  into.push(node);
  return flatten(into, node.children);
};

export const isValidId = (id: number) => id && id > 0;

export const isDateBefore = (thisDate: moment.Moment, checkDate: moment.Moment): boolean => thisDate.isBefore(checkDate);

export const formattedDate = (date) => (date ? moment(date).format(defaultDateFormat[0]) : null);
export const viewDate = (date) => (date ? moment(date) : null);

export const sumValues = (firstValue, secondValue) => {
  return firstValue + secondValue;
};

export const Months = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" }
];

export const asMoney: Partial<ColumnType<unknown>> = {
  align: "right",
  render: (val) => `$ ${Number(val)?.toFixed(2) ?? "0.00"}`
};

export const asDate: Partial<ColumnType<unknown>> = {
  render: (val) => (val ? moment(val).format(defaultDateFormat[0]) : "N/A")
};

export const asDecimal: Partial<ColumnType<unknown>> = {
  align: "right",
  render: (val) => Number(val).toFixed(2)
};

export const defaultDateFormat = ['MM-DD-YYYY', 'MM/DD/YYYY'];

export const sortColumn = (value) => ({ sorter: (a, b) => a[value] - b[value] });

export const calculateNextBillDate = (date, frequency, occurance) => {
  if (frequency === 0.5) {
    const finalDate = moment(date).add(Math.ceil(0.5 * occurance), "month");
    if (occurance % 2 !== 0) {
      finalDate.subtract(2, "weeks");
    }
    return moment(finalDate).format(defaultDateFormat[0]);
  }
  return moment(date).add(frequency, "months").format(defaultDateFormat[0]);
};

export const lockboxExceptions = (id) => {
  let returnObject = { message: "", color: "exception-white" };
  const exceptions = {
    0: { message: "Accounts Not Found", color: "exception-red" },
    1: { message: "Payment Blocked", color: "exception-yellow" },
    2: { message: "Over Payment", color: "exception-coral" },
    3: { message: "Inactive Account", color: "exception-sandybrown" },
    4: { message: "Zero Balance", color: "exception-lightgreen" },
    5: { message: "Under Payment", color: "exception-powderblue" },
    6: { message: "Manual Edit", color: "exception-khaki" },
    7: { message: "Not Imported", color: "exception-grey" }
  };
  if (exceptions[id]) {
    returnObject = exceptions[id];
  }
  return returnObject;
};

export const getQueryParams = (requestObject) => {
  let apiParams = "";
  for (const eachParam in requestObject) {
    if (![undefined, null, ""].includes(requestObject[eachParam])) {
      if (!apiParams) {
        apiParams = "?";
      } else {
        apiParams += "&";
      }
      apiParams += `${eachParam}=${requestObject[eachParam]}`;
    }
  }
  return apiParams;
};

export enum QueryList {
  TRCRDaily = 1,
  TRCRArraignment = 2,
  TRCRAttorney = 3,
  TRCRAgency = 4,
  CivilDaily = 5,
  CivilAttorney = 6
}

export const resetFilters = (clearFilters, confirm) => {
  clearFilters();
  confirm();
};

export const recoveryQuestions = [
  { ID: 1, QUESTION: 'What is your Favorite Pet\'s Name?' },
  { ID: 2, QUESTION: 'What is your Mother\'s Maiden Name?' },
  { ID: 3, QUESTION: 'What is your Place of Birth?' },
  { ID: 4, QUESTION: 'What is your Favorite Food?' }
]

export const requiredValidation = [{ required: true }]
export const whitespaceValidation = [{ whitespace: true }]
export const allValidation = [{ required: true, whitespace: true }]